/* The floating nav's links, in order. The home hero keeps its top 58px clear
 * for this pill, so it must stay short enough to fit a 280px phone. */
export const NAV_LINKS = [
    { href: '/', label: "Home" },
    { href: '/about', label: "About" },
    { href: '/contact', label: "Contact" }
]

/* The masthead and footer credits shared by every inner page, mirroring the
 * Loupe hero's own chrome. */
export const CHROME = {
    brand: "Loupe",
    brandSub: "Type & Optics",
    meta: ["Glass over type", "One held frame", "Autumn 2026"],
    footLeft: "© 2026 Loupe",
    footRight: "In support of",
    footRightName: "Slow reading"
}
